import { PayloadAction } from '@reduxjs/toolkit'

import { RequestStatus } from 'clickNgo/configs/service/common'
import { IForm } from 'core-components/classes/models/IForm'

import { mapContactsWithMultiplePartnersFromCrud } from '../../services/mapping/mapCommonData'
import { IContactsWithMultiplePartnersParams, IOnboardingState } from '../models'

/* getContactsWithMultiplePartners */
export const getContactsWithMultiplePartnersPending = (
  state: IOnboardingState,
  action: PayloadAction<unknown, string, { arg: IContactsWithMultiplePartnersParams }>
) => {
  const { meta } = action

  state.commonData.contactsWithMultiplePartners.meta = meta
  state.commonData.contactsWithMultiplePartners.status = RequestStatus.PENDING
  state.commonData.contactsWithMultiplePartners.message = ''
}

export const getContactsWithMultiplePartnersRejected = (
  state: IOnboardingState,
  action: PayloadAction<unknown, string, { arg: IContactsWithMultiplePartnersParams }>
) => {
  const { meta } = action

  state.commonData.contactsWithMultiplePartners.meta = meta
  state.commonData.contactsWithMultiplePartners.status = RequestStatus.REJECTED
  state.commonData.contactsWithMultiplePartners.message = action.payload as string
}

export const getContactsWithMultiplePartnersFulfilled = (
  state: IOnboardingState,
  action: PayloadAction<IForm | null, string, { arg: IContactsWithMultiplePartnersParams }>
) => {
  const { meta, payload } = action

  state.commonData.contactsWithMultiplePartners.meta = meta
  state.commonData.contactsWithMultiplePartners.status = RequestStatus.FULFILLED
  state.commonData.contactsWithMultiplePartners.message = ''
  if (payload && payload.contacts) {
    state.commonData.contactsWithMultiplePartners.data = mapContactsWithMultiplePartnersFromCrud(
      payload.contacts
    )
  }
}
